// src/layouts/MainLayout.js
import React from 'react';
import { Box } from '@mui/joy';
import Sidebar from './Sidebar';
import Header from './Header';
import Footer from './Footer';
import { Outlet } from 'react-router-dom';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/joy';

export default function MainLayout() {
  const [open, setOpen] = React.useState(false);
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Box sx={{ display: 'flex', position: 'relative' }}>
      <Sidebar open={open} setOpen={setOpen} />

      {open && isSmallScreen && (
        <Box
          onClick={() => setOpen(false)}
          sx={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            bgcolor: 'rgba(0, 0, 0, 0.3)',
            zIndex: 1100,
            cursor: 'pointer',
          }}
        />
      )}

      <Box
        sx={{
          flex: 1,
          ml: { xs: 0, md: '250px' },
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh',
        }}
      >
        <Header open={open} setOpen={setOpen} />
        
        <Box sx={{ flex: 1, p: 3 }}>
          <Outlet />
        </Box>

        <Footer />
      </Box>
    </Box>
  );
}
